import useSWRMutation from 'swr/mutation';
import { confirmRecoveryCodeRequest, type ConfirmRecoveryCodeRequestParams } from '../requests';

export function useConfirmRecoveryCodeMutation() {
  const { trigger, data, isMutating, error, reset } = useSWRMutation(
    'confirm-recovery-code-mutation',
    (_, { arg }: { arg: ConfirmRecoveryCodeRequestParams }) => confirmRecoveryCodeRequest(arg),
  );

  return {
    confirmRecoveryCode: trigger,
    confirmRecoveryCodeData: data,
    isConfirmingRecoveryCode: isMutating,
    resetConfirmRecoveryCode: reset,
    confirmRecoveryCodeError: error,
  };
}
